import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { useState } from 'react'
import { Dropdown } from 'primereact/dropdown';
import { PropTypes } from 'prop-types'
import { useEffect } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import { useRequest } from 'hooks/useRequest'
import moment from 'moment';
import useToast from 'hooks/useToast'
import useEditor from 'hooks/useEditor'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {setEdittedRow} from 'redux/features/projectDetail/projectDetailSlice';

const Team = (props) => {
	const { projectId } = useParams()
    const { edittedRow } = useSelector((state) => state.projectDetail)
    const dispatch = useDispatch()
    const [addRateDialog, setAddRateDialog] = useState(false);
    const [projectTeam, setProjectTeam] = useState([]);
    const [allUser, setAllUser] = useState([]);
    const [allRole, setAllRole] = useState([]);
    const [roles, setRole] = useState([]);
    const [user, setUser] = useState([]);
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const [date3, setDate3] = useState(null);
    const [date, setDate] = useState(null);
    const { calendarEditor, selectEditor, rowEditorBody } = useEditor()

    const projectTeamFunc = () => {
        request('/Project/GetByProjectRoles', {
            method: 'GET', params: { id: projectId }
        }).then((res) => {
            if (res?.data?.result) {
                setProjectTeam(res.data.result)
            }
            dispatch(setEdittedRow({}))
        })

        request('/Account/GetAllUsers', {
            method: 'GET'
        }).then((res) => {
            if (res?.data?.result) {
                setAllUser(res.data.result)
            }
        })

        request('/Role/GetAllRoles', {
            method: 'GET'
        }).then((res) => {
            if (res?.data?.result) {
                setAllRole(res.data.result.map((d) => {
                    return { value: d.id, label: d.name }
                }))

            }
        })
    }
    useEffect(() => {
        projectTeamFunc()
    }, [])
    useEffect(() => {
        props.setWidth("80vw")
    }, [])
   
    const acceptFunc = (rowData) => {
        const deletes = {
            "id": rowData.id,
            "roleId": rowData.roleId,
            "userId": rowData.userId,
            "projectId": rowData.projectId
        };
        request('/Project/DeleteProjectRoles', {
            method: 'DELETE', data: deletes
        }).then((res) => {
            if (res?.data?.result) {
                projectTeamFunc()
                props.fetchProjectDetail()
                showToast('Ekip kişisi silindi.', 'success')
            }
        })
    }
    const buttonTemplate = (rowdata) => {
        return (
            <Icons.deleteNotFill
                onClick={() => {
                    confirmDialog({
                        message: 'Kaydı silmek istiyor musunuz?',
                        header: '',
                        // icon: 'pi pi-info-circle',
                        acceptClassName: 'p-button-danger',
                        accept: () => acceptFunc(rowdata),

                    });
                }}
                size={20}
                className='text-danger cursor-pointer'
            />
        );
    };
    const onRowEditComplete1 = (e) => {
        let _products2 = [...projectTeam];
        let { index } = e;
        _products2[index] = edittedRow;

        request('/Project/UpdateProjectRoles', {
            method: 'PUT', data: edittedRow
        }).then((res) => {
            if (res?.data?.result) {
                projectTeamFunc()
                props.fetchProjectDetail()
                showToast('Ekip Kişi Bilgisi Güncellendi.', 'success')
            }
        })
    }

    const openDialogFunc = () => {
        setAddRateDialog(true)
        props.setWidth("27%")
    }
    const closeDialogFunc = () => {
        setAddRateDialog(false)
        props.setWidth("80vw")
        setDate3(null)
        setDate(null)
        setRole(null)
        setUser(null)
    }
    const addProjectTeam = () => {
        if (roles != null && user != null && date3 != null && projectId != null) {
            let addTeam = {
                "roleId": roles,
                "userId": user,
                "startDate": date3,
                "endDate": date,
                "projectId": projectId
            }
            request('/Project/AddProjectRoles', {
                method: 'POST', data: addTeam
            }).then((res) => {
                if (res?.data.ok) {
                    showToast('Ekip Kişisi Başarılı Şekilde Eklendi.', 'success')
                    closeDialogFunc()
                    projectTeamFunc()
                    props.fetchProjectDetail()
                }else {
                    showToast(res.data?.metadata?.message,'error')
                }
            })
        } else {
            showToast('Tüm Alanları Doldurun!', 'warning')
        }

    }
    return (
        !addRateDialog ? <div>
            <ConfirmDialog />
            <div className="card">
                <Button className='btn-bill' title='Ekip Üyesi Ekle'
                    icon={<Icons.plus size={17} />}
                    handleClick={openDialogFunc} style={{
                        display: "block", marginLeft: "auto",
                        marginRight: "0"
                    }} />
                <DataTable size="small" 
                emptyMessage='Hiç Kayıt Bulunamadı'
                loading={loading}
				onRowEditInit={e => dispatch(setEdittedRow(e.data))}
				responsiveLayout="stack" value={projectTeam} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete1} >
                    <Column 
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="userId" header="Ad Soyad"
                        editor={(options) => selectEditor(options, allUser.map((pt) => ({ label: pt.firstName + " " + pt.lastName, value: pt.id })),true)}
                        style={{ width: 'auto' }}
                        body={(rowData) => {
                            return (
                                <span>{allUser.map((pt) => ({ label: pt.firstName + " " + pt.lastName, value: pt.id })).find(u => u.value == rowData.userId)?.label}</span>
                            )
                        }}
                    />
                    <Column 
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="roleId"
                        header="Rolü" sortable="true"
                        editor={(options) =>
                            selectEditor({ ...options }, allRole)
                        }
                        body={(rowData) => {
                            return (
                                <span>{rowData?.projectRole?.name}</span>
                            )
                        }}
                        style={{ width: 'auto' }}
                        />

                    <Column 
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="startDate" header="Başlangıç Tarihi"
                        sortable="true"
                        editor={(options) => calendarEditor(options)}
                        style={{ width: 'auto' }}
                        body={(rowData) => {
                            const startDate = moment(rowData.startDate).format('LL')
                            return (
                                <span>{startDate != "Invalid date" ? startDate : ""}</span>
                            )
                        }} />

                    <Column 
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="endDate" header="Ayrılış Tarihi"
                        sortable="true" editor={(options) => calendarEditor(options)}
                        style={{ width: 'auto' }}
                        body={(rowData) => {
                            const endDate = moment(rowData.endDate).format('LL')
                            return (<span>{endDate != "Invalid date" ? endDate : ""}</span>)
                        }}
                    />
                    <Column
                        className='text-semi-bold text-sm'
						headerClassName='text-bold bg-primary text-default'
                        rowEditor
                        body={(row, d) => rowEditorBody(d)}
                        style={{ width: '2.5rem' }}
                        />
                    <Column className='text-semi-bold' style={{ width: '2.5rem' }} body={(rowdata) => buttonTemplate(rowdata)}/>
                </DataTable>
            </div>
        </div > : <div>
            <div className="card" style={{ display: "flex", alignItems: "center" }}>
                <div className="field w-100">
                    <Dropdown placeholder='Eklenecek Kişi' className="w-100" inputId="dropdown" value={user} options={allUser.map((pt) => ({ label: pt.firstName + " " + pt.lastName, value: pt.id }))} onChange={(e) => setUser(e.value)} optionLabel="label" />
                </div>
                <div className="field w-100">
                    <Dropdown placeholder='Rolü' className="w-100" inputId="dropdown" value={roles} options={allRole} onChange={(e) => setRole(e.value)} optionLabel="label" />
                </div>
                <div className="field w-100">
                    <Calendar dateFormat='dd/mm/yy'
                        className="w-100" placeholder='Başlangıç Tarihi' id="icon" value={date3 && new Date(date3)} onChange={(e) => setDate3(moment(e.value).add(3, 'hours').toISOString())} showIcon />
                </div>
                <div className="field w-100">
                    <Calendar dateFormat='dd/mm/yy'
                        className="w-100" placeholder='Ayrılış Tarihi' id="icon" value={date && new Date(date)} onChange={(e) => setDate(moment(e.value).add(3, 'hours').toISOString())} showIcon />
                </div>
                <Button className='btn-bill w-100' title='Ekle / Güncelle' handleClick={addProjectTeam} />

                <Button className='btn-bill w-100' title='Vazgeç' handleClick={closeDialogFunc} />
            </div>
        </div >
    )
}
Team.propTypes = {
    setWidthFunc: PropTypes.func,
};
export default Team
